<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <span v-on="on">
          <slot>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn icon v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </span>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("userSubstitute.userReplacementForm.title") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-autocomplete
              :items="computedAvailableUsers"
              :label="$t('userSubstitute.userReplacementForm.fields.substituteUser.name') + '*'"
              :rules="validators.substitute_user_id"
              v-model="contextUserSubstitute.substitute_user_id"
            >
            </v-autocomplete>

            <date-time-picker-computed
              class="px-1"
              :date-time-model.sync="contextUserSubstitute.from_date"
              :label="$t('userSubstitute.userReplacementForm.fields.fromTime.name')"
              :placeholder="$t('userSubstitute.userReplacementForm.fields.fromTime.placeholder')"
            />

            <date-time-picker-computed
              class="px-1"
              :date-time-model.sync="contextUserSubstitute.to_date"
              :label="$t('userSubstitute.userReplacementForm.fields.toTime.name')"
              :placeholder="$t('userSubstitute.userReplacementForm.fields.toTime.placeholder')"
            />

            <v-text-field :label="$t('global.comment')" v-model="contextUserSubstitute.comment"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import DateTimePickerComputed from "../CustomInputComponents/DateTimePickerComputed.vue";

export default {
  name: "UserSubstituteForm",
  components: { DateTimePickerComputed },
  props: {
    userSubstitute: {
      required: false,
      default: () => ({
        id: null,
        substitute_user_id: null,
        from_date: null,
        to_date: null,
        comment: null
      })
    }
  },
  data: () => {
    return {
      contextUserSubstitute: null,
      dialog: false,
      formValid: true,
      availableUsers: []
    };
  },
  computed: {
    validators() {
      return {
        substitute_user_id: [this.contextUserSubstitute.substitute_user_id != null || this.$t("global.error.required")],
        from_date: [
          //v => (v != null && v.length > 0) || 'Nazwa jest wymagana' //TODO WALIDATOR data nie moze byc pozniejsza niz data koncowa
        ],
        to_date: [
          //v => (v != null && v.length > 0) || 'Nazwa jest wymagana' //todo walidator data nie moze byc wcześniejsza niż data początkowa
        ]
      };
    },
    computedAvailableUsers() {
      let result = [];
      for (let user of this.availableUsers) {
        if (user.id !== this.$store.state.Auth.userProperties.user_id) {
          result.push({ value: user.id, text: user.name + " " + user.surname });
        }
      }
      return result;
    }
  },
  beforeMount() {
    this.contextUserSubstitute = this.userSubstitute;
  },
  created() {
    this.axios.get("user-substitute/available-users").then(resp => {
      this.availableUsers = resp.data;
    });
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("user-substitute/item-save", this.contextUserSubstitute)
          .then(() => {
            if (this.userSubstitute.id == null) {
              this.contextUserSubstitute.substitute_user_id = null;
              this.contextUserSubstitute.absent_user_id = null;
              this.contextUserSubstitute.from_date = null;
              this.contextUserSubstitute.to_date = null;
              this.contextUserSubstitute.comment = null;
            }
            this.$store.dispatch("AUTH_UPDATE_SETTINGS").then(() => {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.saved")
              });
              this.$emit("saved");
              this.dialog = false;
            });
          })
          .catch(resp => {
            console.log(resp.response);
          });
      }
    }
  }
};
</script>

<style scoped></style>
